import ListGiftCompo from "../../Components/Gift/ListGiftCompo";
const ListGift = () => {
  return (
    <>
      <ListGiftCompo/>
    </>
  );
};

export default ListGift;
